<template>
    <div>
        <div class="heads">
            <div class="heads-shuio">
                <!-- <p class="heads_title">{{headTitle}}</p>
                <p class="en_title">INTEGRATION OF EDUCATION AND INDUSTR</p> -->
                

                <div class="avatar" v-if="shif" @click.stop="gomy" @mouseenter="hoverSwitch=true"  @mouseleave="hoverSwitch=false">
                    <img :src="user.image" alt="T" />
                    <p class="username omit" v-if="!hoverSwitch">{{user.name}}</p>
                    <div class="user_opt" v-if="hoverSwitch">
                        <div class="opt_item" @click.stop="gomy">个人中心</div>
                        <div class="opt_item" @click.stop="logout">退出登录</div>
                    </div>
                </div>
                <div v-else>
                    <div class="login" @click.stop="goLogin">点击登录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "heads",

        comments:{
        },
        data () {
            return {
                src: "/static/image/ding_bg.png",
                shif:0,
                user:{},
                hoverSwitch: false,
                headTitle: '', //大标题
            }
        },
        created(){
            this.users();
            this.getBannerTitle()
        },
        methods:{
            users(){
                let user=JSON.parse(sessionStorage.getItem("user"))
                if (user){
                    this.shif=1;
                    this.user=user

                    if (!user.image){
                        this.user.image="/static/image/wan_icon.png"
                    }
                    console.log("user:",this.user)
                } else {
                    this.shif=0;
                }
            },
            goLogin(){
                // alert(123)
                this.$router.push({ path: '/login' })
            },
            gomy(){
                this.$router.push({ path: '/my' })
            },
            goindex(){
                this.$router.push({ path: '/home' })
            },
            logout(){
                sessionStorage.clear();
                this.$router.push({ path: '/login' })
                this.$router.go(0)
            },
            //获取大标题
            getBannerTitle(){
                this.$ajax({
                    method: 'post',
                    url: this.$api+ 'home/hometitle',
                }).then(response=>{
                    let data = response.data
                    if(data.code ==1){
                        this.headTitle = data.data
                    }else{
                        console.log(data.msg)
                    }
                })
            }
        },

    }
</script>
<style>
    .heads  .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
</style>
<style scoped>
    .heads  .omit {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .heads {
        background: url("/static/image/banner.png") no-repeat center;
        /* background: url("/static/image/banner.png") no-repeat; */
        width: 100%;
        /* min-width: 1050px; */
        height: 270px;
    }
    .heads  .heads-shuio {
        width: 1064px;
        margin: 0 auto;
        text-align: center;
        /* line-height: 400px; */
        color: white;
        position: relative;
        font-size:50px;
        font-weight:500;
        color:rgba(255,255,255,1);
    }
    .heads .avatar {
        position: absolute;
        top: 20px;
        right: -130px;
        width:85px;
        /* background: red; */
        /* text-align: center; */
        /*right: 200px;*/
    }
    .heads .username{
        /* width: 60px; */
        font-size:12px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:17px;
        max-width: 85px;
        cursor: pointer;
        text-align: center;
    }
    .heads  .avatar img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
    }
    .heads  .login{
        position: absolute;
        top: 20px;
        right: 0;
        width: 70px;
        font-size: 12px;
        border: 1px solid #C9C9C9;
        line-height: 30px;
        cursor: pointer;
    }
.user_opt{
    width:85px;
    height:74px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.17);
    border-radius:4px;
    /* position: absolute;
    right: -14px;
    top: 86px; */
    padding: 10px;
    box-sizing: border-box;
}
.user_opt .opt_item{
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(34,34,34,1);
    line-height:30px;
    text-align: center;
    cursor: pointer;
}
.heads-shuio .heads_title{
    padding-top: 85px;
}
.heads-shuio .en_title{
    font-size:40px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:56px;
    margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/heads.vue